module.exports = __webpack_public_path__ + "img/lunch.325cfab5.png";